import React, { useEffect, useRef } from 'react'

export default function ReauthorizationSubmissionDialog({ submitting, onCancel, onConfirm }) {
    const cancelRef = useRef(null)
    useEffect(() => cancelRef.current?.focus(), [])
    return (
        <div role="dialog" aria-modal="true" aria-labelledby="reauthorization-submit-title" className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/50 p-4">
            <div className="w-full max-w-xl rounded-2xl bg-white p-6 shadow-xl">
                <p className="text-xs font-semibold uppercase tracking-wide text-blue-700">Program Governance</p>
                <h2 id="reauthorization-submit-title" className="mt-1 text-2xl font-bold">Submit Reauthorization Request</h2>
                <p className="mt-3 text-sm text-slate-600">This will freeze the Management request and submit it for Board review. Submission does not change the current Program authorization.</p>
                <div className="mt-6 flex justify-end gap-3">
                    <button ref={cancelRef} type="button" disabled={submitting} onClick={onCancel} className="rounded-lg border px-4 py-2 font-semibold">Cancel</button>
                    <button type="button" disabled={submitting} onClick={onConfirm} className="rounded-lg bg-blue-700 px-4 py-2 font-semibold text-white disabled:opacity-60">{submitting ? 'Submitting…' : 'Submit for Board Review'}</button>
                </div>
            </div>
        </div>
    )
}
